import { orderIsFreeDutiesEligible } from "../../utils/orderIsFreeDutiesEligible";
import { RequestDutiesRefundCTA } from "./ctas";
import { TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE } from "./shared";
export var HowDutiesWorkIA = function HowDutiesWorkIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return ORDER_NOT_SELECTED(strictLocalize);
  }
  return orderIsFreeDutiesEligible(brandOrder) ? DUTIES_FREE_ORDER(strictLocalize) : NON_DUTIES_FREE_ORDER(strictLocalize);
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize, articles) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return undefined;
  }
  if (!orderIsFreeDutiesEligible(brandOrder)) {
    return undefined;
  }
  return RequestDutiesRefundCTA(strictLocalize, articles);
};
var ORDER_NOT_SELECTED = function ORDER_NOT_SELECTED(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return HOW_DUTIES_WORK(strictLocalize);
    },
    getDescription: function getDescription() {
      return [DUTIES_ARE_CALCULATED_ON_THE_TYPE_OF_GOODS(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var DUTIES_FREE_ORDER = function DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return HOW_DUTIES_WORK(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var NON_DUTIES_FREE_ORDER = function NON_DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return HOW_DUTIES_WORK(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var HOW_DUTIES_WORK = function HOW_DUTIES_WORK(strictLocalize) {
  return strictLocalize({
    id: "xfT++X",
    defaultMessage: [{
      "type": 0,
      "value": "Como funcionam os direitos aduaneiros com a Faire"
    }]
  });
};
var DUTIES_ARE_CALCULATED_ON_THE_TYPE_OF_GOODS = function DUTIES_ARE_CALCULATED_ON_THE_TYPE_OF_GOODS(strictLocalize) {
  return strictLocalize({
    id: "X6z/E+",
    defaultMessage: [{
      "type": 0,
      "value": "Os direitos aduaneiros são calculados com base no tipo de produtos importados, conforme determinado pelos códigos de tarifa indicados pela marca. Como os direitos aduaneiros estão cobertos para a sua encomenda, aplicaremos um desconto à sua fatura durante o check-out que reflete o custo estimado dos direitos aduaneiros de importação da sua encomenda. A transportadora enviará uma fatura de todos os custos de importação (incluindo os direitos aduaneiros de importação e o IVA) que pagará na íntegra. Se o custo real dos direitos aduaneiros de importação e das taxas de desembolso for superior à promoção de direitos aduaneiros que recebeu, pode solicitar o reembolso da diferença em crédito Faire quando a encomenda for entregue."
    }]
  });
};
var ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "nyTq3Z",
    defaultMessage: [{
      "type": 0,
      "value": "Esta encomenda é elegível para a promoção de direitos aduaneiros gratuitos. Os direitos aduaneiros são calculados com base no tipo de produtos importados, conforme determinado pelos códigos de tarifa indicados pela marca. Se os direitos aduaneiros estiverem cobertos para a sua encomenda, aplicaremos um desconto à sua fatura durante o check-out que reflete o custo estimado dos direitos aduaneiros de importação da sua encomenda. A transportadora enviará uma fatura de todos os custos de importação (incluindo os direitos aduaneiros de importação e o IVA) que pagará na íntegra. Se o custo real dos direitos aduaneiros de importação e das taxas de desembolso for superior à promoção que recebeu, pode solicitar o reembolso da diferença em crédito Faire quando a encomenda for entregue."
    }]
  });
};
var ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "S1hVGp",
    defaultMessage: [{
      "type": 0,
      "value": "Esta encomenda não é elegível para a promoção de direitos aduaneiros gratuitos. Os direitos aduaneiros são calculados com base no tipo de produtos importados, conforme determinado pelos códigos de tarifa indicados pela marca. A transportadora enviará uma fatura de todos os custos de importação (incluindo os direitos aduaneiros de importação e o IVA) que pagará na íntegra. Se os direitos aduaneiros estiverem cobertos para a sua encomenda, aplicaremos um desconto à sua fatura durante o check-out que reflete o custo estimado dos direitos aduaneiros de importação da sua encomenda."
    }]
  });
};